<template>
	<div class="unread-badge" :class="{ small, 'has-dot': isDot }">
		<span v-if="unreadCount" v-text="unreadCount" />
		<span v-if="isDot" class="dot" />
		<slot />
	</div>
</template>

<script>
import { MAX_UNREADS, UNREAD_LABEL } from '@/helpers/constants'
export default {
	name: 'UnreadBadge',
	props: {
		unread: {
			type: Number,
			default: null,
		},
		small: {
			type: Boolean,
			default: null,
		},
		showDot: {
			type: Boolean,
			default: null,
		},
	},

	computed: {
		isDot() {
			return this.showDot && !this.unreadCount
		},
		unreadCount() {
			return this.unread >= MAX_UNREADS ? UNREAD_LABEL : this.unread
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.unread-badge {
	@include flex(4px);
	justify-content: center;
	color: #ffffff;
	background-color: var(--red-400);
	border-radius: 2rem;
	@include fontFamily(800);
	font-size: 12px;
	padding: 3px 8px;
	min-width: 20px;
	height: 20px;
	padding: 0 6px;
	&.small {
		padding-top: 1px;
		min-width: 48px;
		height: 16px;
		font-size: 10px;
	}
	.dot {
		$dot-size: 4px;
		width: $dot-size;
		height: $dot-size;
		border-radius: $dot-size;
		background-color: white;
	}
}
</style>
